"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultKeyMap = void 0;

var _types = require("./types");
/**
 * Mapping for a default US-104-QWERTY keyboard
 */


var defaultKeyMap = [].concat(_toConsumableArray('0123456789'.split('').map(function (c) {
  return {
    code: "Digit".concat(c),
    key: c
  };
})), _toConsumableArray(')!@#$%^&*('.split('').map(function (c, i) {
  return {
    code: "Digit".concat(i),
    key: c,
    shiftKey: true
  };
})), _toConsumableArray('abcdefghijklmnopqrstuvwxyz'.split('').map(function (c) {
  return {
    code: "Key".concat(c.toUpperCase()),
    key: c
  };
})), _toConsumableArray('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(function (c) {
  return {
    code: "Key".concat(c),
    key: c,
    shiftKey: true
  };
})), [// alphanumeric block - functional
{
  code: 'Space',
  key: ' '
}, {
  code: 'AltLeft',
  key: 'Alt',
  location: _types.DOM_KEY_LOCATION.LEFT,
  keyCode: 18
}, {
  code: 'AltRight',
  key: 'Alt',
  location: _types.DOM_KEY_LOCATION.RIGHT,
  keyCode: 18
}, {
  code: 'ShiftLeft',
  key: 'Shift',
  location: _types.DOM_KEY_LOCATION.LEFT,
  keyCode: 16
}, {
  code: 'ShiftRight',
  key: 'Shift',
  location: _types.DOM_KEY_LOCATION.RIGHT,
  keyCode: 16
}, {
  code: 'ControlLeft',
  key: 'Control',
  location: _types.DOM_KEY_LOCATION.LEFT,
  keyCode: 17
}, {
  code: 'ControlRight',
  key: 'Control',
  location: _types.DOM_KEY_LOCATION.RIGHT,
  keyCode: 17
}, {
  code: 'MetaLeft',
  key: 'Meta',
  location: _types.DOM_KEY_LOCATION.LEFT,
  keyCode: 93
}, {
  code: 'MetaRight',
  key: 'Meta',
  location: _types.DOM_KEY_LOCATION.RIGHT,
  keyCode: 93
}, {
  code: 'OSLeft',
  key: 'OS',
  location: _types.DOM_KEY_LOCATION.LEFT,
  keyCode: 91
}, {
  code: 'OSRight',
  key: 'OS',
  location: _types.DOM_KEY_LOCATION.RIGHT,
  keyCode: 91
}, {
  code: 'CapsLock',
  key: 'CapsLock',
  keyCode: 20
}, {
  code: 'Backspace',
  key: 'Backspace',
  keyCode: 8
}, {
  code: 'Enter',
  key: 'Enter',
  keyCode: 13
}, // function
{
  code: 'Escape',
  key: 'Escape',
  keyCode: 27
}, // arrows
{
  code: 'ArrowUp',
  key: 'ArrowUp',
  keyCode: 38
}, {
  code: 'ArrowDown',
  key: 'ArrowDown',
  keyCode: 40
}, {
  code: 'ArrowLeft',
  key: 'ArrowLeft',
  keyCode: 37
}, {
  code: 'ArrowRight',
  key: 'ArrowRight',
  keyCode: 39
}, // control pad
{
  code: 'Home',
  key: 'Home',
  keyCode: 36
}, {
  code: 'End',
  key: 'End',
  keyCode: 35
}, {
  code: 'Delete',
  key: 'Delete',
  keyCode: 46
}, {
  code: 'PageUp',
  key: 'PageUp',
  keyCode: 33
}, {
  code: 'PageDown',
  key: 'PageDown',
  keyCode: 34
} // TODO: add mappings
]);
exports.defaultKeyMap = defaultKeyMap;